import classStore from './class';

export default {
  namespaced:true,
  modules:{
    class: classStore
  }
}
